import axios from 'axios';
import dayjs from "dayjs";
 
 export default {

      //建当发送复核申请
     sendInform(name,client,goods,price,deta,ACCESS_TOKEN,pnum,cost,info){
         //第一次推送发公众号复核模板消息  "/api/cgi-bin/message/wxopen/template/uniform_send?access_token="
        axios
          .post(
            "/api/cgi-bin/message/template/send?access_token=" +
              ACCESS_TOKEN,
            {
              touser: info.touser, //ot6pe5UKeXz0gtSlOV1YothNNqQQ  .touser
              // mp_template_msg: {
                appid: info.mpappId,   //info.mpappId
                template_id: info.fhTemplate,  //info.fhTemplate
                url: "http://weixin.qq.com",
                miniprogram: {
                  appid: info.xcxappId,
                  pagepath: `components/review/index?pnum=${pnum}`,
                },
                data: {
                  first: {
                    value: `${deta}由经办人：${name}发起了业务复核申请,票号：${pnum}`,
                    color: "#173177",
                  },
                  keyword1: {
                    value: client,
                    color: "#173177",
                  },
                  keyword2: {
                    value: goods,
                    color: "#173177",
                  },
                  keyword3: {
                    value: price + '元',
                    color: "#173177",
                  },
                  keyword4: {
                    value: cost + '元',
                    color: "#173177",
                  },
                  keyword5: {
                    value: name,
                    color: "#173177",
                  },
                  remark: {
                    value:
                      "点击查看物品详情，并前往复核",
                    color: "#173177",
                  },
                },
              // },
            }
          ).then(res=>{
            console.log(res)
          })
       
     },

    //  回收发送复核申请
     sendRecycleInform(name,username,goods,price,weight,deta,ACCESS_TOKEN,pnum,info){
      //发公众号复核模板消息
     axios
       .post(
         "/api/cgi-bin/message/template/send?access_token=" +
           ACCESS_TOKEN,
         {
           touser: info.touser, //ot6pe5cMagF59URlzBimGw0OVm9k
          //  mp_template_msg: {
             appid: info.mpappId,
             template_id: info.hsTemplate,
             url: "http://weixin.qq.com",
             miniprogram: {
               appid:info.xcxappId,
               pagepath: `components/recycleReview/index?pnum=${pnum}`,
             },
             data: {
               first: {
                 value: `${deta}由经办人：${name}发起了回收业务复核申请,票号：${pnum}`,
                 color: "#173177",
               },
               keyword1: {
                 value: username,
                 color: "#173177",
               },
               keyword2: {
                 value: goods,
                 color: "#173177",
               },
               keyword3: {
                 value: price + '元',
                 color: "#173177",
               },
               keyword4: {
                 value: weight + 'g',
                 color: "#173177",
               },
               keyword5: {
                 value: name,
                 color: "#173177",
               },
               remark: {
                 value:
                   "点击查看物品详情，并前往复核",
                 color: "#173177",
               },
             },
          //  },
         }
       )
  },

  // 新工单提醒
  sendOrder(date,state,name,type,pnum,remark,ACCESS_TOKEN,info){

    axios
    .post(
      "/api/cgi-bin/message/template/send?access_token=" +
        ACCESS_TOKEN,
      {
        touser: info.touser, //ot6pe5cMagF59URlzBimGw0OVm9k
        // mp_template_msg: {
          appid: info.mpappId,
          template_id: info.xgdTemplate,
          url: "http://weixin.qq.com",
          miniprogram: {
            appid:info.xcxappId,
            pagepath: `components/review/index?pnum=${pnum}`,
          },
          data: {
            first: {
              value: `票号：${pnum},业务复核已完成`,
              color: "#173177",
            },
            keyword1: {
              value: state,
              color: "#173177",
            },
            keyword2: {
              value: date,
              color: "#173177",
            },
            keyword3: {
              value: name + `${type}`,
              color: "#173177",
            },
            
            
            remark: {
              value:remark,
              color: "#173177",
            },
          },
        // },
      }
    )
  },

     //续当小票打印
     print(state,datas,days,price,startDate,endDeta,name,timeStamp){
      axios.post("/print/print/index",{
          client_id:"1048203564",
          access_token:"56e738f57c1241429082058b7bd9129b",
          machine_code:"4004786329",
          content:`********************************<CA><FS><FB>《${state}小票》</FB></FS><CA>\r \r \r<LR>交易类型：${state}支付</LR>\r<LR>票号：${datas.ticketnumber}</LR>\r<LR>典当物品：${datas.objname}</LR>\r<LR>当户姓名：${datas.name}</LR>\r<LR>付款时间：${dayjs().format("YYYY-MM-DD HH:mm:ss")}</LR>\r<LR>典当金额：${datas.price}元</LR>\r<LR>续当天数：${days}天</LR>\r<LR>典当综合费：${price}元</LR>\r<LR>续当开始日期：${startDate}</LR>\r<LR>续当到期日期：${endDeta}</LR>\r<LR>操作人：${name}</LR>\r<LR>操作日期：${dayjs().format("YYYY-MM-DD")}</LR>\r<LR>付款单号:${timeStamp}</LR>\r <QR>http://weixin.qq.com/r/iXUrM1TERQk6rRBQ9yCb</QR>\r<CA>扫码注册会员享优惠</CA>  \r \r \r`,
          origin_id:"2022030714" + dayjs().unix(),
          sign:"e7e7a7cd30170348d49abf489326a96f",
          id:"3F2509E0-4F89-11D3-914C-03"+ dayjs().unix(),
          timestamp:"1646631947"
      })
    },


    //发送支付申请
    sendPay(name,client,goods,price,deta,ACCESS_TOKEN,pnum,weight){
      //发公众号付款模板消息
     axios
       .post(
         "/api/cgi-bin/message/wxopen/template/uniform_send?access_token=" +
           ACCESS_TOKEN,
         {
           touser: "ot6pe5UKeXz0gtSlOV1YothNNqQQ", //ot6pe5UKeXz0gtSlOV1YothNNqQQ
           mp_template_msg: {
             appid: "wx9019ccce538953c5",
             template_id: "KA2joeaBcCqg86rIXzsY7Yt6mPquyS-Athn71lRcM5s",
             url: "http://weixin.qq.com",
             miniprogram: {
               appid: "wx153c354afba9df6f",
               pagepath: `components/payreview/index?pnum=${pnum}`,
             },
             data: {
               first: {
                 value: `${deta}：由经办人：${name}发起了付款申请申请,票号：${pnum}`,
                 color: "#173177",
               },
               keyword1: {
                 value: pnum,
                 color: "#173177",
               },
               keyword2: {
                 value: client,
                 color: "#173177",
               },
               keyword3: {
                 value: goods,
                 color: "#173177",
               },
               keyword4: {
                 value: price + '元',
                 color: "#173177",
               },
               keyword5: {
                 value: name,
                 color: "#173177",
               },
               remark: {
                 value:
                   `该物品重量为${weight+'/g'}点击查看物品详情，并前往审批`,
                 color: "#173177",
               },
             },
           },
         }
       )
  },

  //阿拉伯数字转大写

  digitUppercase(n) {
    let fraction = ["角", "分"];
    let digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
    let unit = [
      ["元", "万", "亿"],
      ["", "拾", "佰", "仟"],
    ];
    let head = n < 0 ? "欠" : "";
    n = Math.abs(n);
    let s = "";
    for (let i = 0; i < fraction.length; i++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(
        /零./,
        ""
      );
    }
    s = s || "整";
    n = Math.floor(n);
    for (let i = 0; i < unit[0].length && n > 0; i++) {
      let p = "";
      for (let j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
    }
    return (
      head +
      s
        .replace(/(零.)*零元/, "元")
        .replace(/(零.)+/g, "零")
        .replace(/^整$/, "零元整")
    );
  },

 }